module.exports = __webpack_public_path__ + "img/7-icono-mis-ordenes.1ed43d98.svg";